export enum PayableTypes {
  Credit = "Crédito",
  Refund = "Cancelamento",
  RefundReversal = "Estorno de cancelamento",
  Chargeback = "Estorno",
  ChargebackRefund = "Cancelamento de estorno",
}
